import Modal from '../../components/Modal';
import TaskResultLinksSection from './TaskResultLinksSection';

const AI_AGENTS = [
    { slug: 'analyst', name: 'Аналитик' },
    { slug: 'product', name: 'Товарный агент' },
    { slug: 'reference', name: 'Справочный агент' },
    { slug: 'seo', name: 'SEO-агент' },
    { slug: 'ads', name: 'Рекламный агент' },
    { slug: 'pricing', name: 'Агент цен и акций' },
    { slug: 'reviews', name: 'Агент отзывов' },
    { slug: 'visual', name: 'Визуальный агент' },
    { slug: 'fbs', name: 'FBS-агент' },
    { slug: 'dbs', name: 'DBS-агент' },
    { slug: 'fbo', name: 'FBO/FBW-агент' },
    { slug: 'pickup', name: 'Агент вывоза товара' },
    { slug: 'certificates', name: 'Агент сертификатов' },
    { slug: 'launch', name: 'Агент запуска товара' },
    { slug: 'support', name: 'Агент поддержки' },
];

function TaskEditModal({
    open,
    onClose,
    panelRef,
    panelStyle,
    onSubmit,
    taskDetail,
    user,
    taskEditForm,
    setTaskEditForm,
    visibleWorkspaces,
    taskEditTagsInput,
    setTaskEditTagsInput,
    handleEditTagsBlur,
    handleEditTagsKeyDown,
    companyUsers,
    getUserLabel,
    toggleEditList,
    marketplaces,
    taskEditBusy,
    onResizeStart
}) {
    if (!open) return null;
    const currentWorkspace = visibleWorkspaces.find(
        (workspace) => String(workspace.id) === String(taskEditForm.workspace_id || taskDetail?.workspace_id)
    );
    const allowedUserIds = new Set((currentWorkspace?.members || []).map((member) => String(member.user_id)));
    const allowedCabinetIds = new Set((currentWorkspace?.cabinets || []).map((cabinet) => String(cabinet.marketplace_account_id)));
    const filteredUsers = currentWorkspace
        ? companyUsers.filter((item) => {
              const id = String(item.id);
              return (
                  allowedUserIds.has(id) ||
                  id === String(user?.id || '') ||
                  id === String(taskDetail?.created_by_id || '') ||
                  id === String(taskDetail?.assignee_id || '')
              );
          })
        : companyUsers;
    const filteredMarketplaces = currentWorkspace
        ? marketplaces.filter((account) => allowedCabinetIds.has(String(account.id)))
        : marketplaces;

    return (
        <Modal open onClose={onClose} title="Изменить задачу" wide resizable panelRef={panelRef} panelStyle={panelStyle}>
            <form className="tasks__form" onSubmit={onSubmit}>
                <div className="tasks__body">
                    <div className="tasks__layout">
                        <div className="tasks__section">
                            {(() => {
                                const canChangeCreator = taskDetail && (taskDetail.created_by_id === user?.id || user?.role === 'admin' || user?.is_owner);
                                return (
                                    <>
                                        {canChangeCreator && (
                                            <label>
                                                Постановщик
                                                <select value={taskEditForm.created_by_id} onChange={(event) => setTaskEditForm({ ...taskEditForm, created_by_id: event.target.value })}>
                                                    <option value="">Не выбран</option>
                                                    {filteredUsers.map((item) => (
                                                        <option key={item.id} value={item.id}>{getUserLabel(item)}</option>
                                                    ))}
                                                </select>
                                            </label>
                                        )}
                                        <label>
                                            Проект
                                            <select
                                                value={taskEditForm.workspace_id}
                                                onChange={(event) => {
                                                    const workspaceId = event.target.value;
                                                    const nextWorkspace = visibleWorkspaces.find((workspace) => String(workspace.id) === String(workspaceId));
                                                    const nextAllowedUserIds = new Set((nextWorkspace?.members || []).map((member) => String(member.user_id)));
                                                    const nextAllowedCabinetIds = new Set((nextWorkspace?.cabinets || []).map((cabinet) => String(cabinet.marketplace_account_id)));
                                                    setTaskEditForm({
                                                        ...taskEditForm,
                                                        workspace_id: workspaceId,
                                                        assignee_id: nextWorkspace && taskEditForm.assignee_id && !nextAllowedUserIds.has(String(taskEditForm.assignee_id)) ? '' : taskEditForm.assignee_id,
                                                        co_assignee_ids: nextWorkspace ? taskEditForm.co_assignee_ids.filter((id) => nextAllowedUserIds.has(String(id))) : taskEditForm.co_assignee_ids,
                                                        watcher_ids: nextWorkspace ? taskEditForm.watcher_ids.filter((id) => nextAllowedUserIds.has(String(id))) : taskEditForm.watcher_ids,
                                                        cabinet_ids: nextWorkspace ? taskEditForm.cabinet_ids.filter((id) => nextAllowedCabinetIds.has(String(id))) : taskEditForm.cabinet_ids,
                                                    });
                                                }}
                                            >
                                                <option value="">Без проекта</option>
                                                {visibleWorkspaces.map((workspace) => (
                                                    <option key={workspace.id} value={workspace.id}>{workspace.name}</option>
                                                ))}
                                            </select>
                                        </label>
                                    </>
                                );
                            })()}
                            <label>
                                Тема
                                <input type="text" value={taskEditForm.title} onChange={(event) => setTaskEditForm({ ...taskEditForm, title: event.target.value })} required />
                            </label>
                            <label>
                                Описание
                                <textarea rows={12} value={taskEditForm.description} onChange={(event) => setTaskEditForm({ ...taskEditForm, description: event.target.value })} />
                            </label>
                            <div className="tasks__dates">
                                <label>
                                    Начало
                                    <input type="datetime-local" value={taskEditForm.start_at} onChange={(event) => setTaskEditForm({ ...taskEditForm, start_at: event.target.value })} />
                                </label>
                                <label>
                                    Дата выполнения
                                    <input type="datetime-local" value={taskEditForm.due_at} onChange={(event) => setTaskEditForm({ ...taskEditForm, due_at: event.target.value })} />
                                </label>
                            </div>
                            <label>
                                Теги (через запятую)
                                <input type="text" value={taskEditTagsInput} onChange={(event) => setTaskEditTagsInput(event.target.value)} onBlur={handleEditTagsBlur} onKeyDown={handleEditTagsKeyDown} />
                            </label>
                        </div>
                        <div className="tasks__section">
                            <label>
                                Тип исполнителя
                                <select
                                    value={taskEditForm.assignee_type || 'user'}
                                    onChange={(event) => {
                                        const type = event.target.value;
                                        setTaskEditForm({
                                            ...taskEditForm,
                                            assignee_type: type,
                                            assignee_id: type === 'ai_agent' ? '' : taskEditForm.assignee_id,
                                            ai_agent_slug: type === 'user' ? '' : taskEditForm.ai_agent_slug,
                                        });
                                    }}
                                >
                                    <option value="user">Сотрудник</option>
                                    <option value="ai_agent">AI-агент</option>
                                </select>
                            </label>
                            {(taskEditForm.assignee_type || 'user') === 'user' ? (
                                <label>
                                    Главный исполнитель
                                    <select value={taskEditForm.assignee_id} onChange={(event) => setTaskEditForm({ ...taskEditForm, assignee_id: event.target.value })}>
                                        <option value="">Не выбран</option>
                                        {filteredUsers.map((item) => (
                                            <option key={item.id} value={item.id}>{getUserLabel(item)}</option>
                                        ))}
                                    </select>
                                </label>
                            ) : (
                                <label>
                                    AI-агент
                                    <select value={taskEditForm.ai_agent_slug || ''} onChange={(event) => setTaskEditForm({ ...taskEditForm, ai_agent_slug: event.target.value })}>
                                        <option value="">Автовыбор по задаче</option>
                                        {AI_AGENTS.map((agent) => (
                                            <option key={agent.slug} value={agent.slug}>{agent.name}</option>
                                        ))}
                                    </select>
                                </label>
                            )}
                            {(taskEditForm.assignee_type || 'user') === 'user' && (
                                <div className="tasks__pick tasks__pick--scroll">
                                    <h4>Соисполнители</h4>
                                    <div className="tasks__options">
                                        {filteredUsers.map((item) => (
                                            <button type="button" key={item.id} className={`tasks__option ${taskEditForm.co_assignee_ids.includes(item.id) ? 'active' : ''}`} onClick={() => toggleEditList('co_assignee_ids', item.id)}>
                                                {getUserLabel(item)}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                            <div className="tasks__pick tasks__pick--scroll">
                                <h4>Наблюдатели</h4>
                                <div className="tasks__options">
                                    {filteredUsers.map((item) => (
                                        <button type="button" key={item.id} className={`tasks__option ${taskEditForm.watcher_ids.includes(item.id) ? 'active' : ''}`} onClick={() => toggleEditList('watcher_ids', item.id)}>
                                            {getUserLabel(item)}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="tasks__pick tasks__pick--scroll">
                                <h4>Кабинеты</h4>
                                <div className="tasks__options">
                                    {filteredMarketplaces.map((account) => (
                                        <button type="button" key={account.id} className={`tasks__option ${taskEditForm.cabinet_ids.includes(account.id) ? 'active' : ''}`} onClick={() => toggleEditList('cabinet_ids', account.id)}>
                                            {account.account_name}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {taskDetail?.id && (
                        <div className="tasks__result-links-wrap">
                            <TaskResultLinksSection
                                taskId={taskDetail.id}
                                taskWorkspaceId={taskEditForm.workspace_id || taskDetail?.workspace_id}
                                visibleWorkspaces={visibleWorkspaces}
                                marketplaces={marketplaces}
                                cabinetIds={taskEditForm.cabinet_ids}
                            />
                        </div>
                    )}
                </div>
                <div className="tasks__actions">
                    <button type="button" className="ghost" onClick={onClose}>Отмена</button>
                    <button type="submit" disabled={taskEditBusy}>Сохранить</button>
                </div>
            </form>
            <div className="modal__resizer" role="presentation" onMouseDown={onResizeStart} />
        </Modal>
    );
}

export default TaskEditModal;
